import { Button } from '@mui/material';
import CustomModal from '../../../../common-utilities/core/modal';
import {
  formatGRNExtraCharges,
  getGRNGrandTotal,
} from '../grn-details/helper';

const GrnCreatedModal = ({ grnDetails, pendingWith }) => {
  const data = grnDetails?.data;

  return (
    <>
      {data && (
        <CustomModal title={grnDetails?.title} disabledOutsideClick={true}>
          <div className="finance-v2-po-info-container">
            <div className="po-info-section">
              <span>GRN No. </span>
              <span>{data?.grnNo}</span>
            </div>
            <div className="po-info-section">
              <span>PO Number </span>
              <span>{data?.poNumber}</span>
            </div>

            <div className="po-info-section">
              <span>Extra Charges </span>
              <span>
                {formatGRNExtraCharges(
                  data?.poDetails?.extraCharges,
                  data?.receivedExtraCharges
                )}
              </span>
            </div>

            <div className="po-info-section">
              <span>Total GRN Amount </span>
              <span>
                {getGRNGrandTotal({
                  purchaseOrderId: data?.poDetails,
                  receivedItems: data?.receivedItems,
                  receivedExtraCharges: data?.receivedExtraCharges,
                })}
              </span>
            </div>

            <div className="po-info-section">
              <span>Vendor Name </span>
              <span>{data?.poDetails?.vendorName}</span>
            </div>

            <div className="po-info-section">
              <span>Vendor Code </span>
              <span>{data?.poDetails?.vendorCode}</span>
            </div>

            <Button
              fullWidth
              variant="outlined"
              onClick={grnDetails?.onOk}
              size="small"
            >
              Ok
            </Button>
          </div>
        </CustomModal>
      )}
    </>
  );
};

export default GrnCreatedModal;
